document.addEventListener('DOMContentLoaded', function () {
    const moduleElements = document.querySelectorAll('[data-module]');
    const loadedModules = {}; // Objet pour stocker les modules déjà chargés

    moduleElements.forEach((element) => {
        const moduleName = element.getAttribute('data-module');

        // Vérifier si le module a déjà été chargé
        if (!loadedModules[moduleName]) {

            loadedModules[moduleName] = true;
            import(`@/${moduleName}.js`)
                .then((module) => {
                    
                    module.init();
                    // console.log(` module ${moduleName} chargé `);
                    // Marquer le module comme chargé
                })
                .catch((error) => {
                    console.error(`Erreur de chargement du module ${moduleName}:`, error);
                });
        } else {
            console.log(`Le module ${moduleName} est déjà chargé.`);
        }
    });
});
